var map = {
	"./en/blockchainBalance.json": 55160,
	"./es/blockchainBalance.json": 21612,
	"./fr/blockchainBalance.json": 49670,
	"./it/blockchainBalance.json": 31529,
	"./pt-BR/blockchainBalance.json": 44656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92329;